<form [formGroup]="verrekenbareVerliezenFG">
    <div *ngIf="onverrekendeBuitenlandseBronheffing.length > 0">
        <div formArrayName="onverrekendeBuitenlandseBronheffing">
            <div *ngFor="let verlies of onverrekendeBuitenlandseBronheffing.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijvingBronheffing"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragBronheffing"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijOnverrekendeBuitenlandseBronheffing(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     class="delete"
                                     icon="trash"
                                     id="buttonDeleteBronheffing"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="onverrekendeBuitenlandseBronheffing.length === 0">
        <snelstart-ui-button (click)="addRijOnverrekendeBuitenlandseBronheffing()" class="snelstart-ui-button" icon="plus"
                             type="link">Onverrekende buitenlandse
            bron-/dividendbelasting voorgaande jaren
        </snelstart-ui-button>
    </div>
    <div *ngIf="onverrekendeBuitenlandseBronheffing.length > 0">
        <snelstart-ui-button (click)="addRijOnverrekendeBuitenlandseBronheffing()" class="snelstart-ui-button" icon="plus"
                             type="link">Bron-/dividendbelasting voorgaande
            jaren toevoegen
        </snelstart-ui-button>
    </div>

</form>


